import guidedDefaultImg from "@/assets/route-guided-default.jpg";
import specializedDefaultImg from "@/assets/route-specialized-default.jpg";
import selfPacedDefaultImg from "@/assets/route-selfpaced-default.jpg";

/** Imagen de portada de una ruta: la configurada, o la default según tipo. */
export function routeImage(program: {
  image_url?: string | null;
  modality?: string | null;
  category?: string | null;
} | null | undefined): string {
  if (!program) return guidedDefaultImg;
  if (program.image_url) return program.image_url;
  if (program.modality === "self_paced") return selfPacedDefaultImg;
  return program.category === "specialized" ? specializedDefaultImg : guidedDefaultImg;
}
